export default "__VITE_ASSET__BSLspyb2__"